import * as React from 'react';
import './spinner.css';

const spinner = () => {
  return <div className='spinner'></div>
}

export default spinner;